<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            label: String,
            value: [String, Number],
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            bonus: {
                type: Boolean,
                default: true,
            },
            contragentType: {
                type: Number
            }
        },
        data() {
            return {
                val: 0,
            }
        },
        methods: {
            change(v) {
                this.$emit('change', v);
            }
        },
        computed: {
            ...mapState('dictionary/paymentCategory', {
                d_list: state => state.list
            }),
            list() {
                return this.d_list.filter(i => {
                    if (!this.bonus && i.value === 2) return false;
                    if (!this.contragentType) return true;
                    if (this.contragentType <= 2) return true;
                    return i.value !== 2;

                })
            },
        },
        watch: {
            value(v) {
                this.val = v;
            },
            val(v) {
                this.$emit('input', v);
            },
        },
        components: {},
        mounted() {
            this.val = this.value;

        },
        destroyed() {

        },
    }
</script>
<template>
    <div class="input-payment-category">
        <div class="el-input-group el-input--mini" :class="{'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <el-select v-model="val" :disabled="disabled" :clearable="clearable" @change="change">
                <el-option v-for="item in list" :value="item.value" :key="item.value" :label="item.label"></el-option>
            </el-select>
        </div>
    </div>
</template>
<style lang="scss">
    .input-payment-category {
        .el-select {
            width: 100%;
        }
    }
</style>
